import { CategoryRankingPanel } from '@/components/ranking/CategoryRankingPanel';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useMyClubs } from '@/hooks/useMyClubs';
import { getClubSportUids } from '@/utils/club-utils';
import { Building2, Medal } from 'lucide-react';
import type React from 'react';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Rankings: React.FC = () => {
  const navigate = useNavigate();
  const { clubs, loading } = useMyClubs();
  const [selectedClubId, setSelectedClubId] = useState<string | undefined>(
    undefined,
  );

  // Falls back to the first club until the user picks one.
  const club = clubs.find((c) => c.id === selectedClubId) ?? clubs[0];
  const clubId = club?.id;
  const clubSportUids = useMemo(
    () => (club ? getClubSportUids(club.courts) : undefined),
    [club],
  );

  return (
    <div className="w-full">
      <div className="mb-[26px] flex items-start gap-3">
        <div className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-[11px] bg-gc-navySoft text-gc-navy">
          <Medal size={22} />
        </div>
        <div>
          <h2 className="text-[23px] font-bold tracking-[-0.4px] text-gc-ink">
            Rankings
          </h2>
          <p className="mt-1 text-[13.5px] text-gc-muted">
            Ranking de puntos por categoría de cada uno de tus clubes.
          </p>
        </div>
      </div>

      {!loading && clubs.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <Building2 size={40} className="mb-4 text-gc-muted" />
          <h3 className="mb-1 text-[16px] font-bold text-gc-ink">
            Todavía no tenés clubes
          </h3>
          <p className="mb-6 text-[13.5px] text-gc-muted">
            Cuando seas dueño, manager o profesor de un club, vas a ver su
            ranking acá.
          </p>
          <Button onClick={() => navigate('/clubs')}>Ir a mis clubes</Button>
        </div>
      ) : (
        <>
          <div className="mb-6">
            <Select
              value={clubId ?? ''}
              onValueChange={setSelectedClubId}
              disabled={loading}
            >
              <SelectTrigger className="w-[280px]">
                <SelectValue
                  placeholder={loading ? 'Cargando clubes...' : 'Elegí un club'}
                />
              </SelectTrigger>
              <SelectContent>
                {clubs.map((club) => (
                  <SelectItem key={club.id} value={club.id}>
                    {club.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <CategoryRankingPanel
            clubId={clubId}
            clubSportUids={clubSportUids}
          />
        </>
      )}
    </div>
  );
};

export default Rankings;
